/*
Parameter: fields object:
{
    firstname: String,
    lastname: String,
    birthday: String of form MM/DD/YYYY,
    dateadministered: String of form MM/DD/YYYY,
    testid: String
}
*/
// method that sends info to update REDCap
export async function exportToRedCap(fields) {
    const url = 'https://redcap.dellmed.utexas.edu/api/'

    let recordID = fields.birthday.replaceAll("/", "-") + fields.firstname + fields.lastname;
  
    const testdata = [{
      record_id: recordID.toString(),
      redcap_repeat_instrument: "form_1",
      redcap_repeat_instance: "new",
    }]

    Object.keys(fields).forEach((key) => {
      if (fields[key] != null) {
        testdata[0][key] = fields[key].toString();
      }
    });

    testdata[0]["form_1_complete"] = "2" // for the "complete" flag to be set

    const body = new FormData();
    body.append('token', '4D0191746EB5F84CE4AF7824ABB5808E'); // Varshinee's key
    body.append('content', 'record');
    body.append('format', 'json');
    body.append('type', 'flat');
    body.append('data', JSON.stringify(testdata));
  
    const params = {
      method: 'POST',
      body,
    }
  
  return await fetch(url, params)
    .then(data => {
      console.log('fetch data: ', data)
    })
    .catch(error => console.log('Error: ', error))
  }

